import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface UploadedVideo {
  id: string;
  file_name: string;
  file_path: string;
  alt_text: string;
  section: string;
  duration: number;
  created_at: string;
  publicUrl: string;
}

export const useUploadedVideo = (section: string) => {
  const [currentVideo, setCurrentVideo] = useState<UploadedVideo | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchLatestVideo = async () => {
    try {
      setLoading(true);
      
      const response = await supabase.functions.invoke(`get-videos?section=${section}`);
      
      if (response.error) {
        throw response.error;
      }

      const videos = response.data.videos || [];
      if (videos.length > 0) {
        setCurrentVideo(videos[0]); // Get the latest video
      }
    } catch (error) {
      console.error('Error fetching latest video:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLatestVideo();
  }, [section]);

  const updateCurrentVideo = (videoData: UploadedVideo) => {
    setCurrentVideo(videoData);
  };

  return {
    currentVideo,
    loading,
    updateCurrentVideo,
    refetch: fetchLatestVideo
  };
};